/* eslint-disable */
export const fsaErrorLogger = (/* store */) => (next) => (action) => {
  // for all actions received that comply with the FSA spec,
  const { isAxiosError } = action.payload || {};
  if (action.error === true || isAxiosError) {
    const matches = document.location.origin.match(/localhost/g);
    const sandbox = matches !== null;
    if (sandbox) {
      // in sandbox just push the error to console
      console.error(
        `Promise-generating redux action ${action.type} threw an error: ${
          action.payload
        }`
      ); // eslint-disable-line no-console
    }
  }
  return next(action);
};
/* eslint-enable */
